// extracted by mini-css-extract-plugin
module.exports = {"root":"modal-header-description_root__bQJ4V"};